export const PROJECT_TYPE_OPTIONS = [
  { value: 'INCLUDE_SCHEDULED', label: '예정사업 포함' },
  { value: 'ONLY_FAVORITE', label: '관심사업만' },
];
